export type ReportPlatformBlock =
  | { kind: 'facebook_reactions' }
  | { kind: 'instagram_interactions' }
  | { kind: 'facebook_content_posts' }
  | { kind: 'facebook_content_reels' }
  | { kind: 'instagram_content_feed' }
  | { kind: 'instagram_content_reels' }
  | { kind: 'instagram_content_stories' }
  | { kind: 'linkedin_content_posts' };

export const FACEBOOK_REACTION_METRIC_KEYS = [
  'reactions_like',
  'reactions_love',
  'reactions_haha',
  'reactions_wow',
  'reactions_sad',
  'reactions_angry',
] as const;

export const INSTAGRAM_INTERACTION_METRIC_KEYS = [
  'likes',
  'comments',
  'shares',
  'saves',
  'reposts',
] as const;

export function shouldShowFacebookReactionsCard(
  performanceMetrics: string[],
): boolean {
  return performanceMetrics.some((metric) =>
    (FACEBOOK_REACTION_METRIC_KEYS as readonly string[]).includes(metric),
  );
}

export function shouldShowInstagramInteractionsCard(
  performanceMetrics: string[],
): boolean {
  return performanceMetrics.some((metric) =>
    (INSTAGRAM_INTERACTION_METRIC_KEYS as readonly string[]).includes(metric),
  );
}
